import { render, staticRenderFns } from "./ValidationHintCpt.vue?vue&type=template&id=c6a05bb2&"
import script from "./ValidationHintCpt.vue?vue&type=script&lang=ts&"
export * from "./ValidationHintCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports